import { theme } from '@prose-ui';
import { styled } from '@prose-ui/legacy';
import { mediaMinWidth } from '@prose-ui/utils/media';

import type { StaticImageData } from 'Components/Image';
import Spacer from 'Components/Spacer';
import { Typography } from 'Components/Typography';

const CardContainer = styled.div<{ hasSubtitle: boolean }>`
  position: relative;

  height: ${({ hasSubtitle }) => (hasSubtitle ? 300 : 260)}px;
  width: 100%;

  color: inherit;

  ${mediaMinWidth('md')} {
    height: ${({ hasSubtitle }) => (hasSubtitle ? 325 : 285)}px;
  }

  ${mediaMinWidth('lg')} {
    height: ${({ hasSubtitle }) => (hasSubtitle ? 300 : 260)}px;
  }
`;

const CardInfoContainer = styled.div`
  position: absolute;
  bottom: 0;

  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 210px;
  width: 100%;
  padding: ${theme.spacing['4x']};
  border-radius: ${theme.radius.xs};
  background-color: white;
`;

const ImageContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;

  height: 160px;
  width: 160px;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const StyledTypographyIngredientName = styled(Typography)`
  /* TODO: @nelly: font size not in the theme */
  font-size: 18px;
  font-family: ${theme.typography.fontFamily.heading};
  color: ${theme.colors.primary[400]};
`;
const StyledTypographyIngredientDesc = styled(Typography)`
  height: 50px;

  font-size: ${theme.typography.fontSize.xs};
  line-height: 1.3;
  color: ${theme.colors.primary[300]};
`;

const StyledTypographyIngredientSubtitle = styled(Typography)`
  font-size: ${theme.typography.fontSize.xs};
  color: ${theme.colors.primary[400]};
`;

type IngredientCardProps = {
  ingredient: {
    ingredientName: string;
    subtitle?: string;
    description: string;
    img: {
      imgSrc: StaticImageData;
      imgAlt: string;
    };
  };
};

export const IngredientCard = ({ ingredient }: IngredientCardProps) => {
  const { ingredientName, description, img, subtitle } = ingredient;

  return (
    <CardContainer hasSubtitle={Boolean(subtitle)}>
      <ImageContainer>
        <Image alt={`${img.imgAlt}-picture`} src={img.imgSrc.src} />
      </ImageContainer>
      <CardInfoContainer>
        <StyledTypographyIngredientName markupName="h3">
          {ingredientName}
        </StyledTypographyIngredientName>
        {subtitle && (
          <StyledTypographyIngredientSubtitle markupName="p">
            {subtitle}
          </StyledTypographyIngredientSubtitle>
        )}
        <Spacer size={12} />
        <StyledTypographyIngredientDesc markupName="p">
          {description}
        </StyledTypographyIngredientDesc>
        <Spacer size={12} />
      </CardInfoContainer>
    </CardContainer>
  );
};
